document.addEventListener("DOMContentLoaded", () => {
  const FREE_GIFT_KEYWORDS = ["free gift"];
  const REQUIRED_QTY_FOR_GIFT = 6; // Threshold to allow gift checkout

  /**
   * Helper: Find elements across Shadow DOMs
   */
  function deepQuerySelectorAll(root, selector) {
    let result = [...root.querySelectorAll(selector)];
    root.querySelectorAll("*").forEach((el) => {
      if (el.shadowRoot) {
        result = result.concat(deepQuerySelectorAll(el.shadowRoot, selector));
      }
    });
    return result;
  }

  /**
   * Helper: Find Checkout Buttons
   */
  function deepFindCheckoutButtons(root) {
    let found = [...root.querySelectorAll('[name="checkout"], [href="/checkout"], form[action="/checkout"] [type="submit"]')];
    
    // Fallback: search by likely classes/ids if standard attributes miss
    if (found.length === 0) {
        found = [...root.querySelectorAll('button[id*="checkout"], button[class*="checkout"]')];
    }

    root.querySelectorAll('*').forEach(el => {
      if (el.shadowRoot) {
        found = found.concat(deepFindCheckoutButtons(el.shadowRoot));
      }
    });
    return found;
  }

  /**
   * Helper: Toggle Checkout Button State
   */
  function toggleCheckoutButtons(shouldDisable) {
    const buttons = deepFindCheckoutButtons(document);
    
    buttons.forEach((btn) => {
      if (shouldDisable) {
        btn.disabled = true;
        btn.style.opacity = "0.5";
        btn.style.cursor = "not-allowed";
        btn.style.pointerEvents = "none"; 
        btn.dataset.giftLock = "true";
        // Optional: Change text to explain why
        // btn.innerText = "Add more items"; 
      } else {
        // Only re-enable if WE were the ones who locked it
        if (btn.dataset.giftLock === "true") {
            btn.disabled = false;
            btn.style.opacity = "";
            btn.style.cursor = "";
            btn.style.pointerEvents = "";
            delete btn.dataset.giftLock;
        }
      }
    });
  }

  /**
   * Main Logic: Hide controls AND Validate Gift Threshold
   */
  function scanCart() {
    let hasGift = false;
    let nonGiftTotalQty = 0;

    const listItems = deepQuerySelectorAll(document, '[role="listitem"]');

    listItems.forEach((item) => {
      const titleEl = item.querySelector("p.font-semibold");
      if (!titleEl) return; // skip if no title found

      const title = titleEl.innerText.toLowerCase();
      const isGift = FREE_GIFT_KEYWORDS.some((k) => title.includes(k));

      // 1. Get Quantity of this item
      const qtyInput = deepQuerySelectorAll(item, 'input[name="quantity"]')[0];
      const qtyValue = parseInt(qtyInput ? qtyInput.value : "1", 10) || 1;

      if (isGift) {
        hasGift = true;
        
        // --- UI CLEANUP FOR GIFT ---
        
        // Hide quantity wrapper
        const qtyWrappers = deepQuerySelectorAll(
          item,
          ".flex.items-center.rounded-storefront-drawer.border"
        );
        qtyWrappers.forEach((el) => (el.style.display = "none"));

        // Hide remove button
        const removeSvgs = deepQuerySelectorAll(item, "button svg.lucide-trash2");
        removeSvgs.forEach((svg) => {
          const btn = svg.closest("button");
          if (btn) btn.style.display = "none";
        });

        // Insert/Update Static Text
        let qtyLabel = item.querySelector(".gift-qty-label");
        if (!qtyLabel) {
          qtyLabel = document.createElement("div");
          qtyLabel.className = "gift-qty-label";
          qtyLabel.style.fontSize = "14px";
          qtyLabel.style.opacity = "0.6";
          qtyLabel.style.marginTop = "4px";

          const priceContainer = item.querySelector(".flex.justify-between.gap-2");
          if (priceContainer && priceContainer.parentNode) {
            priceContainer.parentNode.appendChild(qtyLabel);
          }
        }
        qtyLabel.innerText = `Qty: ${qtyValue}`;

      } else {
        // It is a normal product, add to total count
        nonGiftTotalQty += qtyValue;
      }
    });

    // --- CHECKOUT VALIDATION ---
    // If we have a gift, BUT regular items are less than 6, BLOCK checkout.
    const shouldBlock = hasGift && (nonGiftTotalQty < REQUIRED_QTY_FOR_GIFT);
    
    toggleCheckoutButtons(shouldBlock);
  }

  /**
   * Click Guard: Final line of defense
   */
  function checkoutGuard(e) {
    let hasGift = false;
    let nonGiftTotalQty = 0;

    // Recalculate on click to be 100% sure
    [...deepQuerySelectorAll(document, '[role="listitem"]')].forEach(item => {
        const title = item.querySelector("p.font-semibold")?.innerText.toLowerCase() || "";
        const isGift = FREE_GIFT_KEYWORDS.some(k => title.includes(k));
        const qtyInput = deepQuerySelectorAll(item, 'input[name="quantity"]')[0];
        const qtyValue = parseInt(qtyInput ? qtyInput.value : "1", 10) || 1;

        if (isGift) hasGift = true;
        else nonGiftTotalQty += qtyValue;
    });

    if (hasGift && nonGiftTotalQty < REQUIRED_QTY_FOR_GIFT) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      console.warn("Checkout prevented: Gift present without 6 qualifying items.");
      return false;
    }
  }

  // --- INIT ---

  // 1. Run immediately
  scanCart();

  // 2. Observe DOM changes
  const observer = new MutationObserver(() => scanCart());
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // 3. Fallback poll (keep UI clean and buttons updated)
  setInterval(scanCart, 800);

  // 4. Attach Click Guard
  function attachCheckoutGuardDeep() {
    const buttons = deepFindCheckoutButtons(document);
    buttons.forEach(btn => {
      if (!btn.dataset.guardAttached) {
        btn.dataset.guardAttached = "1";
        btn.addEventListener("click", checkoutGuard, { capture: true });
      }
    });
  }
  setInterval(attachCheckoutGuardDeep, 1000);
});